var TCPADisclaimer = (function() {

    "use strict";

    const submissionUrl = '/twilio/accept-disclaimer';
    const checkUrl = '/twilio/check-disclaimer';

    function submitAcceptance(success, error) {
        $.ajax({
            url: submissionUrl,
            data: {
                acceptance: 1
            },
            method: 'POST',
            global: false
        })
        .done((data) => {
            success();
        })
        .fail((xhr) => {
            console.error('An error occurred while submitting acceptance', xhr);
            error();
        });
    }

    function requestAcceptance(accepted, cancelled) {
        let message = "I acknowledge that, if contacts express \
        a desire to opt out by a method other than texting 'STOP', \
        I am responsible for contacting Support or adjusting the contact record.";

        return confirmModal(message)
            .then(() => {
                submitAcceptance(accepted, cancelled);
            })
            .fail(cancelled);
    }

    /**
     * This method checks that the disclaimer has been accepted, if it already has,
     * the resolve callback will be called.  If it hasn't, the request acceptance modal
     * will be shown and send the resolve callback through that confirm modal.
     * @returns {Promise}
     */
    function requireAcceptance() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: checkUrl,
                method: 'GET',
                global: false
            })
            .done((data) => {
                if (data.is_accepted) {
                    resolve();
                } else {
                    requestAcceptance(resolve, reject);
                }
            })
            .fail((xhr) => {
                console.error('An error occurred while checking acceptance.', xhr);
                reject();
            });
        });
    }

    return {
        requireAcceptance: requireAcceptance
    };
})();
window.TCPADisclaimer = TCPADisclaimer;
export {
    TCPADisclaimer
}